import { TextField } from '@mui/material';
import {
  renderCheckboxes,
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import CustomTextField from '../../../../common/CustomTextField';

const EmbryologyBasicTransferDetails = ({
  embryoTransferDetails,
  handleDateChange,
  handleInputChange,
  handleTimeChange,
  handleAdditionalRequirementChange,
  isFrozen = false,
}) => {
  return (
    <div className="card">
      <div className="body" style={{ display: 'flex', gap: '10px' }}>
        <table
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <tbody>
            {isFrozen ? (
              <tr>
                <td colSpan={2}>Oocyte </td>
                <td colSpan={1}>
                  {renderDropdownWithoutLabel(
                    'caseTypeOoctye',
                    embryoTransferDetails.caseTypeOoctye,
                    [' ', 'Self', 'OD'],
                    handleInputChange,
                  )}
                </td>

                <td colSpan={2}>Sperm </td>
                <td colSpan={1}>
                  {renderDropdownWithoutLabel(
                    'caseTypeSperm',
                    embryoTransferDetails.caseTypeSperm,
                    [' ', 'Self', 'DS'],
                    handleInputChange,
                  )}
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={2}>Embryo Transfer </td>
                <td colSpan={1}>
                  {renderDropdownWithoutLabel(
                    'embryoTransfer',
                    embryoTransferDetails.embryoTransfer,
                    [' ', 'Yes', 'No'],
                    handleInputChange,
                  )}
                </td>
              </tr>
            )}
            {!isFrozen && (
              <>
                <tr>
                  <td>Date</td>
                  <td>
                    <DateComponent
                      id="date"
                      selectedDate={
                        embryoTransferDetails.date
                          ? dayjs(embryoTransferDetails.date)
                          : null
                      }
                      handleDateChange={(date, dateString) =>
                        handleDateChange(date, 'date')
                      }
                    />
                  </td>
                  <td>Time </td>
                  <td>
                    <TextField
                      type="time"
                      variant="standard"
                      value={embryoTransferDetails.time}
                      onChange={(e) => handleTimeChange(e.target.value, 'time')}
                    />
                  </td>
                  <td>Media </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'media',
                      embryoTransferDetails.media,
                      handleInputChange,
                    )}
                  </td>
                </tr>

                <tr>
                  <td>Transfer </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      'transfer',
                      embryoTransferDetails.transfer,

                      [' ', 'Self', 'Surrogate'],
                      handleInputChange,
                    )}
                  </td>
                  <td>Surrogate Name</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'surrogateName',
                      embryoTransferDetails.surrogateName,
                      handleInputChange,
                      false,
                      null,
                      embryoTransferDetails.transfer !== 'Surrogate',
                    )}
                  </td>
                  <td>Surrogate Age</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      disabled={embryoTransferDetails.transfer !== 'Surrogate'}
                      value={embryoTransferDetails.surrogateAge}
                      name={'surrogateAge'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                </tr>
                <tr>
                  <td>Surrogate MPI</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'surrogateMPI',
                      embryoTransferDetails.surrogateMPI,
                      handleInputChange,
                      false,
                      null,
                      embryoTransferDetails.transfer !== 'Surrogate',
                    )}
                  </td>
                  <td>Surrogate Aadhar No</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      disabled={embryoTransferDetails.transfer !== 'Surrogate'}
                      value={embryoTransferDetails.surrogateAadharNumber}
                      name={'surrogateAadharNumber'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                </tr>
              </>
            )}
            <tr>
              <td colSpan={6}>
                {renderCheckboxes(
                  embryoTransferDetails.additionalRequirement.map(
                    (item) => item,
                  ),
                  handleAdditionalRequirementChange,
                  'Additional Requirement',
                  'retrieval',
                  embryoTransferDetails.additionalRequirementOther,
                  true,
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default EmbryologyBasicTransferDetails;
